import React, { useEffect, useState } from 'react';
import { getRequest, postRequest, showMessage } from '../../../config';

const S = {
    wrap: { padding: '1.5rem', background: '#f5f6fa', minHeight: 120 },
    card: { background: '#fff', borderRadius: 12, border: '1px solid #e4e8f5', boxShadow: '0 2px 8px rgba(74,103,255,0.06)', overflow: 'hidden' },
    cardHead: { padding: '18px 24px 14px', borderBottom: '1px solid #f0f2ff' },
    title: { fontSize: '1.05rem', fontWeight: 700, color: '#1a1d2e', margin: 0 },
    subtitle: { fontSize: '0.8rem', color: '#7c83a0', marginTop: 4 },
    tableWrap: { overflowX: 'auto', width: '100%' },
    thead: { background: '#f8f9ff' },
    th: { padding: '10px 16px', fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: '#7c83a0', textAlign: 'left', borderBottom: '2px solid #e8eaf5', whiteSpace: 'nowrap' },
    thCenter: { padding: '10px 14px', fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: '#7c83a0', textAlign: 'center', borderBottom: '2px solid #e8eaf5', whiteSpace: 'nowrap' },
    row: (i) => ({ borderBottom: '1px solid #f0f2ff', background: i % 2 === 0 ? '#fff' : '#fafbfe' }),
    modTd: { padding: '11px 16px', display: 'flex', alignItems: 'center', gap: 10 },
    modAccent: { width: 3, height: 30, background: '#4A67FF', borderRadius: 2, flexShrink: 0 },
    modName: { fontSize: '0.85rem', fontWeight: 600, color: '#1a1d2e' },
    modKey: { fontSize: '0.68rem', fontWeight: 700, color: '#4A67FF', background: '#eef0ff', padding: '2px 8px', borderRadius: 10, flexShrink: 0 },
    catTd: { textAlign: 'center', padding: '8px 14px' },
    cb: { width: 15, height: 15, accentColor: '#4A67FF', cursor: 'pointer' },
};

const TempAllocationModule = ({ categoryList }) => {
    const [tempModules, setTempModules] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchTempModules = async () => {
        setLoading(true);
        try {
            const res = await getRequest('/admin/temp-modules-admin', 'not-showMessage');
            if (res?.code === 200) setTempModules(res.body || []);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchTempModules(); }, []);

    const handleAssign = async ({ moduleId, category, valueAssign }) => {
        try {
            const res = await postRequest('/admin/assign/category/temp-module', {
                moduleId,
                categoryId: category._id,
                type: valueAssign,
            });
            if (res?.code === 200) {
                setTempModules(prev => prev.map(mod => {
                    if (String(mod._id) !== String(moduleId)) return mod;
                    return { ...mod, categoryId: valueAssign ? category._id : null };
                }));
                showMessage(res.message || 'Updated.');
            }
        } catch (err) {
            console.error(err);
        }
    };

    if (loading) return <div className="df jcc aic p2rem" style={{ color: '#7c83a0' }}>Loading…</div>;

    const MODULE_COL_PX = 300;
    const CATEGORY_COL_PX = 100;
    const tableWidth = Math.max(MODULE_COL_PX + (categoryList?.length ?? 0) * CATEGORY_COL_PX, 520);

    return (
        <div style={S.wrap}>
            <div style={S.card}>
                <div style={S.cardHead}>
                    <p style={S.title}>Temp Allocation Module Management</p>
                    <p style={S.subtitle}>Assign a category to each temp module. Only one category can be active per module.</p>
                </div>
                <div style={S.tableWrap}>
                    <table style={{ width: tableWidth, minWidth: '100%', borderCollapse: 'collapse' }}>
                        <colgroup>
                            <col style={{ width: MODULE_COL_PX }} />
                            {categoryList.map(cat => <col key={cat._id} style={{ width: CATEGORY_COL_PX }} />)}
                        </colgroup>
                        <thead style={S.thead}>
                            <tr>
                                <th style={S.th}>Module</th>
                                {categoryList.map(cat => (
                                    <th key={cat._id} style={S.thCenter}>{cat.name}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {tempModules.map((mod, i) => (
                                <tr key={mod._id} style={S.row(i)}>
                                    <td>
                                        <div style={S.modTd}>
                                            <div style={S.modAccent} />
                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                <div style={S.modName}>{mod.moduleName}</div>
                                            </div>
                                            {mod.moduleKey && <span style={S.modKey}>{mod.moduleKey}</span>}
                                        </div>
                                    </td>
                                    {categoryList.map(cat => (
                                        <td key={cat._id} style={S.catTd}>
                                            <input
                                                type="checkbox"
                                                style={S.cb}
                                                checked={String(mod.categoryId) === String(cat._id)}
                                                onChange={e => handleAssign({
                                                    moduleId: mod._id,
                                                    category: cat,
                                                    valueAssign: e.target.checked,
                                                })}
                                            />
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default TempAllocationModule;
